import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-15/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "A moving coil microphone loaded with infinite resistance has a 6 m long coil<br>immersed in a 2.5 T magnetic field. The moving mass is 0.2 g, the mechanical<br>resistance is 8 N∙s/m, the compliance of the suspension is 0.5 mm/N and the<br>diaphragm surface is 2 cm<sup>2</sup>. Using the low cut-off frequency and bandwidth<br>sensitivity values, guess which sensitivity curve is the corresponding one.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/15/task/task-3.svg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
